// TODO: import icons
import factureGestion from '@assets/images/gestion-facture.png'
import assistance from '@assets/images/assistance.png'
import iconInnovation from '@assets/icons/icon-innovation.png'

export const serviceItems = [
  {
    title: 'home.service_one_title',
    description: 'home.service_one_description',
    icon: (
      <svg
        width='26'
        height='26'
        viewBox='0 0 26 26'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='1' y='1' width='24' height='24' rx='4' fill='#EBF5FF' />
        <rect x='1' y='1' width='24' height='24' rx='4' stroke='#0F84FF' />
        <path
          d='M4.25 6C4.25 5.27065 4.53973 4.57118 5.05546 4.05546C5.57118 3.53973 6.27065 3.25 7 3.25H17C17.7293 3.25 18.4288 3.53973 18.9445 4.05546C19.4603 4.57118 19.75 5.27065 19.75 6V11.5C19.75 11.6989 19.671 11.8897 19.5303 12.0303C19.3897 12.171 19.1989 12.25 19 12.25C18.8011 12.25 18.6103 12.171 18.4697 12.0303C18.329 11.8897 18.25 11.6989 18.25 11.5V6C18.25 5.31 17.69 4.75 17 4.75H7C6.31 4.75 5.75 5.31 5.75 6V20.382C5.74992 20.4247 5.76076 20.4667 5.78149 20.504C5.80223 20.5413 5.83216 20.5726 5.86845 20.5951C5.90474 20.6175 5.94617 20.6303 5.9888 20.6322C6.03144 20.6342 6.07385 20.6251 6.112 20.606L7.112 20.106C7.40259 19.9607 7.72787 19.8993 8.05143 19.9284C8.37498 19.9575 8.68404 20.0762 8.944 20.271L9.85 20.95C9.89327 20.9825 9.94591 21 10 21C10.0541 21 10.1067 20.9825 10.15 20.95L11.012 20.303C11.2903 20.0945 11.6244 19.9736 11.9718 19.9558C12.3191 19.9379 12.6638 20.024 12.962 20.203L13.636 20.607C13.7215 20.6572 13.7962 20.7238 13.8557 20.803C13.9153 20.8822 13.9586 20.9724 13.9831 21.0685C14.0076 21.1645 14.0128 21.2645 13.9984 21.3625C13.9841 21.4606 13.9504 21.5549 13.8994 21.6398C13.8484 21.7248 13.781 21.7988 13.7012 21.8576C13.6214 21.9164 13.5308 21.9588 13.4345 21.9824C13.3382 22.0059 13.2382 22.0101 13.1403 21.9948C13.0424 21.9794 12.9485 21.9449 12.864 21.893L12.191 21.489C12.1484 21.4633 12.0991 21.4509 12.0494 21.4534C11.9997 21.4559 11.9518 21.4732 11.912 21.503L11.05 22.15C10.7471 22.3772 10.3786 22.5 10 22.5C9.62135 22.5 9.25292 22.3772 8.95 22.15L8.044 21.47C8.00688 21.4424 7.96283 21.4256 7.91675 21.4216C7.87068 21.4175 7.82437 21.4263 7.783 21.447L6.783 21.947C6.5162 22.0805 6.2197 22.1435 5.92167 22.1302C5.62364 22.1168 5.33397 22.0275 5.08017 21.8707C4.82638 21.7139 4.61688 21.4948 4.47158 21.2343C4.32629 20.9737 4.25001 20.6803 4.25 20.382V6Z'
          fill='#0F84FF'
        />
        <path
          d='M18.5 15.75C17.7707 15.75 17.0712 16.0397 16.5555 16.5555C16.0397 17.0712 15.75 17.7707 15.75 18.5C15.75 19.2293 16.0397 19.9288 16.5555 20.4445C17.0712 20.9603 17.7707 21.25 18.5 21.25C19.2293 21.25 19.9288 20.9603 20.4445 20.4445C20.9603 19.9288 21.25 19.2293 21.25 18.5C21.25 17.7707 20.9603 17.0712 20.4445 16.5555C19.9288 16.0397 19.2293 15.75 18.5 15.75ZM14.25 18.5C14.25 17.9419 14.3599 17.3892 14.5735 16.8736C14.7871 16.358 15.1001 15.8894 15.4948 15.4948C15.8894 15.1001 16.358 14.7871 16.8736 14.5735C17.3892 14.3599 17.9419 14.25 18.5 14.25C19.0581 14.25 19.6108 14.3599 20.1264 14.5735C20.642 14.7871 21.1106 15.1001 21.5052 15.4948C21.8999 15.8894 22.2129 16.358 22.4265 16.8736C22.6401 17.3892 22.75 17.9419 22.75 18.5C22.75 19.6272 22.3022 20.7082 21.5052 21.5052C20.7082 22.3022 19.6272 22.75 18.5 22.75C17.3728 22.75 16.2918 22.3022 15.4948 21.5052C14.6978 20.7082 14.25 19.6272 14.25 18.5ZM20.343 17.095C20.4835 17.2356 20.5623 17.4262 20.5623 17.625C20.5623 17.8238 20.4835 18.0144 20.343 18.155L18.063 20.435L16.657 19.03C16.5833 18.9613 16.5242 18.8785 16.4832 18.7865C16.4422 18.6945 16.4202 18.5952 16.4184 18.4945C16.4166 18.3938 16.4352 18.2938 16.4729 18.2004C16.5106 18.107 16.5667 18.0222 16.638 17.951C16.7092 17.8797 16.794 17.8236 16.8874 17.7859C16.9808 17.7482 17.0808 17.7296 17.1815 17.7314C17.2822 17.7332 17.3815 17.7552 17.4735 17.7962C17.5655 17.8372 17.6483 17.8963 17.717 17.97L18.063 18.314L19.283 17.094C19.4236 16.9535 19.6142 16.8747 19.813 16.8747C20.0118 16.8747 20.2024 16.9545 20.343 17.095ZM7.25 8C7.25 7.80109 7.32902 7.61032 7.46967 7.46967C7.61032 7.32902 7.80109 7.25 8 7.25H14.5C14.6989 7.25 14.8897 7.32902 15.0303 7.46967C15.171 7.61032 15.25 7.80109 15.25 8C15.25 8.19891 15.171 8.38968 15.0303 8.53033C14.8897 8.67098 14.6989 8.75 14.5 8.75H8C7.80109 8.75 7.61032 8.67098 7.46967 8.53033C7.32902 8.38968 7.25 8.19891 7.25 8ZM7.25 11C7.25 10.8011 7.32902 10.6103 7.46967 10.4697C7.61032 10.329 7.80109 10.25 8 10.25H16C16.1989 10.25 16.3897 10.329 16.5303 10.4697C16.671 10.6103 16.75 10.8011 16.75 11C16.75 11.1989 16.671 11.3897 16.5303 11.5303C16.3897 11.671 16.1989 11.75 16 11.75H8C7.80109 11.75 7.61032 11.671 7.46967 11.5303C7.32902 11.3897 7.25 11.1989 7.25 11ZM7.25 14C7.25 13.8011 7.32902 13.6103 7.46967 13.4697C7.61032 13.329 7.80109 13.25 8 13.25H11.5C11.6989 13.25 11.8897 13.329 12.0303 13.4697C12.171 13.6103 12.25 13.8011 12.25 14C12.25 14.1989 12.171 14.3897 12.0303 14.5303C11.8897 14.671 11.6989 14.75 11.5 14.75H8C7.80109 14.75 7.61032 14.671 7.46967 14.5303C7.32902 14.3897 7.25 14.1989 7.25 14ZM7.25 17C7.25 16.8011 7.32902 16.6103 7.46967 16.4697C7.61032 16.329 7.80109 16.25 8 16.25H11.5C11.6989 16.25 11.8897 16.329 12.0303 16.4697C12.171 16.6103 12.25 16.8011 12.25 17C12.25 17.1989 12.171 17.3897 12.0303 17.5303C11.8897 17.671 11.6989 17.75 11.5 17.75H8C7.80109 17.75 7.61032 17.671 7.46967 17.5303C7.32902 17.3897 7.25 17.1989 7.25 17Z'
          fill='#0F84FF'
        />
      </svg>
    ), // Remplace par le vrai nom ou composant d’icône
    imgService: factureGestion, // Remplace par ton image
  },
  {
    title: 'home.service_two_title',
    description: 'home.service_two_description',
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='26'
        height='26'
        viewBox='0 0 26 26'
        fill='none'
      >
        <rect x='1' y='1' width='24' height='24' rx='4' fill='#EBF5FF' />
        <rect x='1' y='1' width='24' height='24' rx='4' stroke='#0F84FF' />
        <path
          d='M15.4 17.0055V13.5H16.825V16.179L19.143 17.5185L18.4305 18.7535L15.4 17.0055ZM11.4765 20.872L9.7 22.05L6.85 20.15L4 22.05V4H21.1V11.695C22.278 12.892 23 14.5355 23 16.35C23 20.0265 20.0265 23 16.35 23C15.4345 23.0025 14.5285 22.8147 13.6895 22.4483C12.8505 22.082 12.0969 21.5452 11.4765 20.872ZM10.3935 19.3045C9.947 18.4115 9.7 17.414 9.7 16.35C9.7 12.6735 12.6735 9.69999 16.35 9.69999C17.3665 9.69999 18.3355 9.92799 19.2 10.3365V5.9H5.9V18.497L6.85 17.87L9.7 19.77L10.3935 19.3045ZM16.35 21.1C18.972 21.1 21.1 18.972 21.1 16.35C21.1 13.728 18.972 11.6 16.35 11.6C13.728 11.6 11.6 13.728 11.6 16.35C11.6 18.972 13.728 21.1 16.35 21.1Z'
          fill='#0F84FF'
        />
      </svg>
    ),
  },
  {
    title: 'home.service_three_title',
    description: 'home.service_three_description',
    icon: (
      <svg
        width='26'
        height='26'
        viewBox='0 0 26 26'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='1' y='1' width='24' height='24' rx='4' fill='#EBF5FF' />
        <rect x='1' y='1' width='24' height='24' rx='4' stroke='#0F84FF' />
        <path
          d='M3.5 3V18H5.5V5H18.5V3H3.5ZM11.5 11H18.5V13H11.5V11ZM16.5 15H11.5V17H16.5V15ZM20 21.32L22.5 23V7H7.5V23L10 21.32L12.5 23L15 21.32L17.5 23L20 21.32ZM20.5 9V18.57L17.5 20.59L15 18.9L12.5 20.59L9.5 18.57V9H20.5Z'
          fill='#0F84FF'
        />
      </svg>
    ),
  },
  {
    title: 'home.service_four_title',
    description: 'home.service_four_description',
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='26'
        height='26'
        viewBox='0 0 26 26'
        fill='none'
      >
        <rect x='1' y='1' width='24' height='24' rx='4' fill='#EBF5FF' />
        <rect x='1' y='1' width='24' height='24' rx='4' stroke='#0F84FF' />
        <path
          d='M17 4C17.7652 3.99996 18.5015 4.29233 19.0583 4.81728C19.615 5.34224 19.9501 6.06011 19.995 6.824L20 7V17H20.75C21.397 17 21.93 17.492 21.994 18.122L22 18.25V20C22 20.7652 21.7077 21.5015 21.1827 22.0583C20.6578 22.615 19.9399 22.9501 19.176 22.995L19 23H9C8.23479 23 7.49849 22.7077 6.94174 22.1827C6.38499 21.6578 6.04989 20.9399 6.005 20.176L6 20V10H4.25C3.94054 10.0001 3.64203 9.88549 3.41223 9.67823C3.18244 9.47097 3.03769 9.18583 3.006 8.878L3 8.75V7C2.99996 6.23479 3.29233 5.49849 3.81728 4.94174C4.34224 4.38499 5.06011 4.04989 5.824 4.005L6 4H17ZM17 6H8V20C8 20.2652 8.10536 20.5196 8.29289 20.7071C8.48043 20.8946 8.73478 21 9 21C9.26522 21 9.51957 20.8946 9.70711 20.7071C9.89464 20.5196 10 20.2652 10 20V18.25C10 17.56 10.56 17 11.25 17H18V7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6ZM20 19H12V20C12 20.35 11.94 20.687 11.83 21H19C19.2652 21 19.5196 20.8946 19.7071 20.7071C19.8946 20.5196 20 20.2652 20 20V19ZM13 13C13.2652 13 13.5196 13.1054 13.7071 13.2929C13.8946 13.4804 14 13.7348 14 14C14 14.2652 13.8946 14.5196 13.7071 14.7071C13.5196 14.8946 13.2652 15 13 15H11C10.7348 15 10.4804 14.8946 10.2929 14.7071C10.1054 14.5196 10 14.2652 10 14C10 13.7348 10.1054 13.4804 10.2929 13.2929C10.4804 13.1054 10.7348 13 11 13H13ZM15 9C15.2652 9 15.5196 9.10536 15.7071 9.29289C15.8946 9.48043 16 9.73478 16 10C16 10.2652 15.8946 10.5196 15.7071 10.7071C15.5196 10.8946 15.2652 11 15 11H11C10.7348 11 10.4804 10.8946 10.2929 10.7071C10.1054 10.5196 10 10.2652 10 10C10 9.73478 10.1054 9.48043 10.2929 9.29289C10.4804 9.10536 10.7348 9 11 9H15ZM6 6C5.75507 6.00003 5.51866 6.08996 5.33563 6.25272C5.15259 6.41547 5.03566 6.63975 5.007 6.883L5 7V8H6V6Z'
          fill='#0F84FF'
        />
      </svg>
    ),
  },
  {
    title: 'home.service_five_title',
    description: 'home.service_five_description',
    icon: (
      <svg
        width='26'
        height='25'
        viewBox='0 0 26 25'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='1' y='1' width='24' height='23' rx='4' fill='#EBF5FF' />
        <rect x='1' y='1' width='24' height='23' rx='4' stroke='#0F84FF' />
        <path
          d='M4.5 21C3.95 21 3.47933 20.8043 3.088 20.413C2.69667 20.0217 2.50067 19.5507 2.5 19V8C2.5 7.45 2.696 6.97933 3.088 6.588C3.48 6.19667 3.95067 6.00067 4.5 6H8.5V4C8.5 3.45 8.696 2.97933 9.088 2.588C9.48 2.19667 9.95067 2.00067 10.5 2H14.5C15.05 2 15.521 2.196 15.913 2.588C16.305 2.98 16.5007 3.45067 16.5 4V6H20.5C21.05 6 21.521 6.196 21.913 6.588C22.305 6.98 22.5007 7.45067 22.5 8V11C22.5 11.2833 22.404 11.5167 22.212 11.7C22.02 11.8833 21.7827 11.975 21.5 11.975C21.2173 11.975 20.98 11.8793 20.788 11.688C20.596 11.4967 20.5 11.259 20.5 10.975V8H4.5V19H11C11.2833 19 11.521 19.096 11.713 19.288C11.905 19.48 12.0007 19.7173 12 20C11.9993 20.2827 11.9033 20.5203 11.712 20.713C11.5207 20.9057 11.2833 21.0013 11 21H4.5ZM10.5 6H14.5V4H10.5V6ZM18.5 23C17.1167 23 15.9377 22.5123 14.963 21.537C13.9883 20.5617 13.5007 19.3827 13.5 18C13.4993 16.6173 13.987 15.4383 14.963 14.463C15.939 13.4877 17.118 13 18.5 13C19.882 13 21.0613 13.4877 22.038 14.463C23.0147 15.4383 23.502 16.6173 23.5 18C23.498 19.3827 23.0103 20.562 22.037 21.538C21.0637 22.514 19.8847 23.0013 18.5 23ZM18 19.1L16.55 17.65C16.45 17.55 16.3333 17.5 16.2 17.5C16.0667 17.5 15.95 17.55 15.85 17.65C15.75 17.75 15.7 17.8667 15.7 18C15.7 18.1333 15.75 18.25 15.85 18.35L17.8 20.3C18 20.5 18.2333 20.6 18.5 20.6C18.7667 20.6 19 20.5 19.2 20.3L21.15 18.35C21.25 18.25 21.3 18.1333 21.3 18C21.3 17.8667 21.25 17.75 21.15 17.65C21.05 17.55 20.9333 17.5 20.8 17.5C20.6667 17.5 20.55 17.55 20.45 17.65L19 19.1V15.5C19 15.3667 18.95 15.25 18.85 15.15C18.75 15.05 18.6333 15 18.5 15C18.3667 15 18.25 15.05 18.15 15.15C18.05 15.25 18 15.3667 18 15.5V19.1Z'
          fill='#0F84FF'
        />
      </svg>
    ),
  },
  {
    title: 'home.service_six_title',
    description: 'home.service_six_description',
    icon: (
      <svg
        width='18'
        height='22'
        viewBox='0 0 18 22'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        style={{
          borderRadius: '8px',
          border: '1px solid #7ABBFF',
          background: '#E5F2FF',
        }}
      >
        <path
          d='M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z'
          stroke='#7ABBFF'
          strokeWidth='1.5'
        />
        <path
          opacity='0.5'
          d='M17 16.5C17 18.985 17 21 9 21C1 21 1 18.985 1 16.5C1 14.015 4.582 12 9 12C13.418 12 17 14.015 17 16.5Z'
          stroke='#0F84FE'
          strokeWidth='1.5'
        />
      </svg>
    ),
  },
  {
    title: 'home.service_seven_title',
    description: 'home.service_seven_description',
    icon: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <rect x='0.5' y='0.5' width='23' height='23' rx='3.5' fill='#EBF5FF' />
        <rect
          x='0.5'
          y='0.5'
          width='23'
          height='23'
          rx='3.5'
          stroke='#0F84FF'
        />
        <path
          d='M12.0021 15.6009C13.9901 15.6009 15.6018 13.9893 15.6018 12.0013C15.6018 10.0132 13.9901 8.40161 12.0021 8.40161C10.014 8.40161 8.40234 10.0132 8.40234 12.0013C8.40234 13.9893 10.014 15.6009 12.0021 15.6009Z'
          stroke='#0F84FF'
          stroke-width='1.5'
        />
        <path
          d='M14.7015 9.30157L18.3012 5.7019M5.70215 18.3007L9.30187 14.7011M9.30187 9.30157L5.70215 5.7019M18.3012 18.3007L14.7015 14.7011'
          stroke='#0F84FF'
          stroke-width='1.5'
        />
        <path
          d='M9.67271 3.30729C11.1984 2.89696 12.8054 2.89758 14.3307 3.30909C19.1319 4.59597 21.9802 9.53021 20.6942 14.3304C19.4073 19.1314 14.4738 21.9797 9.67271 20.6937C4.87158 19.4077 2.0233 14.4735 3.3084 9.6724C3.71455 8.14557 4.51746 6.75338 5.63562 5.63717'
          stroke='#0F84FF'
          stroke-width='1.5'
          stroke-linecap='round'
        />
      </svg>
    ),
    imgService: assistance,
  },
]

export const accordionData = [
  {
    _id: '683993290d884193813ee95b',
    name: 'home.intro',
    description:
      'Pro account gives you freedom with uploading HD videos and can also meet all your business needs apasih kamu',
    btn_txt: 'Save $40',
    price: '123',
    btn_try: 'Try 1 month',
  },
  {
    _id: '683993ca0d884193813ee95e',
    name: 'home.base',
    description:
      'Pro account gives you freedom with uploading HD videos and can also meet all your business needs apasih kamu',
    btn_txt: 'Save $40',
    price: '123',
    btn_try: 'Try 1 month',
  },
  {
    _id: '683994610d884193813ee962',
    name: 'home.pro',
    description:
      'Pro account gives you freedom with uploading HD videos and can also meet all your business needs apasih kamu',
    btn_txt: 'Save $40',
    price: '123',
    btn_try: 'Try 1 month',
  },
  {
    name: 'home.enterprise',
    description:
      'Pro account gives you freedom with uploading HD videos and can also meet all your business needs apasih kamu',
    btn_txt: 'Save $40',
    price: '123',
    btn_try: 'Try 1 month',
  },
]
export const infoItems = [
  {
    description: 'home.info_innov_description',
    img: iconInnovation,
    title: 'home.info_innov_title',
    key: 'home.info_innov_description',
  },
  {
    description: 'home.info_simplicity_description',
    img: iconInnovation,
    title: 'home.info_simplicity_title',
    key: 'home.info_simplicity_description',
  },
  {
    description: 'home.info_transp_description',
    img: iconInnovation,
    title: 'home.info_transp_title',
    key: 'home.info_transp_title',
  },
]
